import { render, staticRenderFns } from "./UploadsStage.vue?vue&type=template&id=159288d0&"
import script from "./UploadsStage.vue?vue&type=script&lang=js&"
export * from "./UploadsStage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports